import Button from "../../../../../publicComponent/Button";
import {useAddShopCar} from "../../../../../api/orderShopcarDetail";
import {useQueryParam} from "../../../../../hooks";
import {GoodsDetailController, useGoodsDetailContext} from "../../../../../reducer/moduleReducer/goodsDetail";
import useNotice from "../../../../../hooks/useNotice";
import useRequestTokenAuth from "../../../../../hooks/useRequestTokenAuth";
import {useTranslation} from "react-i18next";
import cookies from "../../../../../utils/cookies";
import ls from "../../../../../utils/ls";
import {mediaMatch} from "../../../../../utils";

export default function AddCartButton({ className, submitAfter, noIcon }) {
  const notice = useNotice();
  const { setSpecModalVisible } = GoodsDetailController();
  const { loading, addHandle } = useAddShopCar();
  const [goodsId] = useQueryParam('goodsId');
  const { state } = useGoodsDetailContext();
  const { detail, count, spec } = state;
  const [auth] = useRequestTokenAuth();
  const { t } = useTranslation();
  const isMdmax = mediaMatch.isMdmax;
  
  const addCartSubmit = async () => {
    let q = {
      itemId: goodsId,
      quantity: count,
      itemSkuId: spec.specSkuId,
    };
    
    if (!spec.specSkuId) {
      if (isMdmax){
        setSpecModalVisible(true);
      }
      
      return notice.warn(t('请选择规格'));
    }
    
    await auth(addCartSubmit, q);
    
    let { data } = await addHandle(q);
    
    if (data) {
      if (submitAfter) {
        submitAfter();
      } else {
        notice.success(t('已添加到购物车'));
      }
    }
  };
  
  return (
    <Button onClick={addCartSubmit}
            loading={loading}
            className={className}>
      {!noIcon && <i className="iconfont icon-shop text-white text-[14px] mr-[5px] md:hidden"></i>}
      {t('加入购物车')}
    </Button>
  );
}
